import React, { useState } from "react";
import FormComponent from "./FormComponent";
import { Form } from "antd";
import { CONSTANT } from "../../../../config/Constant";
import {
  dataToFormDataConverter,
  Notification,
} from "../../../../config/Global";

const AddComponent: React.FC<any> = (props) => {
  const { visible, close, getList } = props;
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const authToken = localStorage.getItem("token");

  var myHeaders = new Headers();
  myHeaders.append("Authorization", authToken ? authToken : "");

  const handleSubmit = async (data?: any) => {
    setLoading(true);
    for (const key in data) {
      if (key.startsWith("file")) {
        delete data[key];
      }
    }

    const formData = dataToFormDataConverter(data);

    if (fileList.length > 0) {
      formData.append("uploaded_file", fileList[0]?.originFileObj);
    }
    try {
      const response = await fetch(
        `${CONSTANT.BASE_URL}/company_management/add`,
        {
          method: "POST",
          body: formData,
          headers: myHeaders,
        }
      );
      const responseData = await response.json();
      if (response.ok) {
        setLoading(false);
        form.resetFields();
        getList();
        close();
        setFileList([]);
        // Notification.success({
        //   message: "File uploaded successfully.",
        // });
      } else {
        if (responseData.notification) {
          Notification.error({
            message: responseData.notification.join(", "), // Combine messages into a single string
          });
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
      Notification.error({
        message: "File upload failed.",
      });
    }
  };

  const handleClose = () => {
    close();
    form.resetFields();
    setFileList([]);
  };
  return (
    <FormComponent
      handleSubmit={handleSubmit}
      form={form}
      visible={visible}
      close={handleClose}
      title={"Add Company Management"}
      loading={loading}
      setFileList={setFileList}
      fileList={fileList}
      type="Add"
    />
  );
};

export default AddComponent;
